var map = {
	"./LCK.png": "2788",
	"./LEC.png": "1115",
	"./LFL.png": "f306",
	"./NLC.png": "a254",
	"./Worlds.png": "3ada",
	"./icons/adc.png": "f5d2",
	"./icons/jun.png": "2ad0",
	"./icons/mid.png": "93b0",
	"./icons/sup.png": "bdb4",
	"./icons/top.png": "c09f",
	"./karmine-banner.png": "f389"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0536";